export enum ELanguage {
  ENGLISH = "en",
  MALAY = "ms",
}
